import { createContext, useContext } from "react";

export const RoutePermissionContext = createContext({
  hasViewPermission: false,
  hasAddPermission: false,
  hasEditPermission: false,
  hasDeletePermission: false,
});

export const useRoutePermissions = () => useContext(RoutePermissionContext);



